/**
 * NSM site config — single source of truth for event, venue, contact, and social.
 * Coming Soon 2026: ticket CTAs disabled; messaging is teaser/announcement.
 * All text is UTF-8; use proper characters (e.g. Düsseldorf, Bahnstraße, ©).
 */

export const site = {
  // Event status
  comingSoon: true,
  eventYear: "2026",

  // Event
  eventName: "Next Super Model",
  eventDate: "2026",
  eventTime: "TBA",
  eventTagline: "Casting & Runway Showcase — Düsseldorf. Coming Soon 2026.",
  eventDescription: "Casting & Runway Showcase — Düsseldorf. Coming Soon 2026.",

  // Teaser copy (Coming Soon)
  heroTitle: "Coming Soon 2026",
  heroSubtitle: "Next Super Model",
  heroTagline: "Casting & Runway Showcase — Düsseldorf. Coming Soon 2026.",
  dateLocationTeaser: "2026 — Düsseldorf, Germany",

  // CTA labels (Coming Soon mode)
  ctaNav: "COMING SOON",
  ctaHero: "COMING SOON 2026",
  ctaFooter: "Coming Soon",

  // Venue (teaser)
  venueName: "Nachtresidenz",
  venueAddress: "Bahnstraße 13, 40212 Düsseldorf",
  venueCityCountry: "Düsseldorf, Germany",
  dressCode: "chic/elegant",

  // Ticket (disabled — do not use for navigation)
  ticketUrl: "#",

  // Social
  instagramUrl: "https://www.instagram.com/next.super.model?igsh=MXkybGI0amdzYmt2dA==",
  facebookUrl: "https://facebook.com/nextsupermodel.de",

  // Contact
  contactEmail: "info@nextsupermodel.de",
  contactPhone: "0211 63550130",
  contactPhoneTel: "+4921163550130",
  companyAddress: "Klosterstraße 20, 40211 Düsseldorf",
  companyAddressLines: ["Klosterstraße 20", "40211 Düsseldorf"],

  // Contact form (FormSubmit)
  formSubmitEmail: "mail@glanzundgloriamodels.de",
  contactIntroTitle: "Contact us",
  contactIntroText: "Write your message below. We'll get back to you as soon as possible.",

  // Hero image (URL or path to assets/branding/hero.jpg when you have one)
  heroImage: "https://placehold.co/1920x800?text=Coming+Soon+2026",

  // Brevo waitlist form (HTML embed — form action URL)
  waitlistFormUrl: "https://879adbd0.sibforms.com/serve/MUIFAKwUIVy3zk18OMQTOpqLWXsUJicQ_5yk0X4SClerEHSlE3TN6pRUthl2ZPeujHgn0PAPp4fjmoAIMU0xhhD_eRvYceYUgw32c30kW2JyLo5GSE0-RIZ3xkYcGRAwig9RLU4j9_PnDdfXDNn8qa5DDPFCU99pNVsBJ0OOYMA-KOp5RwS7A_Hq-sVfNtIqAO-pGXm61JAWYziaug==",
  waitlistTitle: "Join the Waitlist",
  waitlistSubtext: "Be the first to know when casting opens and launch details are announced.",
};

export default site;
